import { get } from '../utils/fetch';

// 根据id查询模版
export const getTemplateById = (params?: { id: string }) => get('/cdp-data/api/v1/template/get-by-id', params,{ visitor: true });

// 通过chatId获取消息
export const geChatMsgs = (chatId) => get(`/cdp-data/web/v1/easy-chat/get-message/${chatId}`, {}, { visitor: true });
